const ALIAS_GROUPS = [
  ['united states', 'united states of america', 'usa', 'u s', 'us'],
  ['turkiye', 'turkey'],
  ['dr congo', 'dem rep congo', 'democratic republic of congo', 'democratic republic of the congo', 'congo kinshasa'],
  ['congo', 'republic of the congo', 'congo brazzaville'],
  ['south korea', 'republic of korea', 'korea republic of'],
  ['north korea', 'dprk', 'democratic peoples republic of korea'],
  ['palestine', 'state of palestine', 'palestinian territory', 'palestinian territories'],
  ['tanzania', 'united republic of tanzania'],
  ['ivory coast', 'cote d ivoire'],
  ['vietnam', 'viet nam'],
  ['iran', 'islamic republic of iran'],
  ['russia', 'russian federation'],
  ['bolivia', 'plurinational state of bolivia'],
  ['venezuela', 'bolivarian republic of venezuela'],
  ['syria', 'syrian arab republic'],
  ['moldova', 'republic of moldova'],
  ['czechia', 'czech republic'],
  ['laos', 'lao peoples democratic republic'],
  ['brunei', 'brunei darussalam'],
  ['eswatini', 'swaziland']
];

function normalizeName(value = '') {
  return String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').replace(/\s+/g, ' ').trim();
}

function canonicalName(value = '') {
  const normalized = normalizeName(value);
  const group = ALIAS_GROUPS.find((aliases) => aliases.some((alias) => normalizeName(alias) === normalized));
  return group ? group[0] : normalized;
}

export function sameCountryName(left, right) {
  const first = canonicalName(left);
  const second = canonicalName(right);
  return Boolean(first && second && first === second);
}


const EXPLICIT_FLAG_CODES = new Map([
  ['united states', 'US'], ['turkiye', 'TR'], ['dr congo', 'CD'], ['congo', 'CG'],
  ['south korea', 'KR'], ['north korea', 'KP'], ['palestine', 'PS'], ['tanzania', 'TZ'],
  ['ivory coast', 'CI'], ['vietnam', 'VN'], ['iran', 'IR'], ['russia', 'RU'],
  ['bolivia', 'BO'], ['venezuela', 'VE'], ['syria', 'SY'], ['moldova', 'MD'],
  ['czechia', 'CZ'], ['laos', 'LA'], ['brunei', 'BN'], ['eswatini', 'SZ'],
  ['united kingdom', 'GB'], ['uk', 'GB'], ['kosovo', 'XK'], ['myanmar', 'MM'],
  ['burma', 'MM'], ['taiwan', 'TW'], ['western sahara', 'EH'], ['south sudan', 'SS'],
  ['central african republic', 'CF'], ['bosnia and herzegovina', 'BA'],
  ['equatorial guinea', 'GQ'], ['dominican republic', 'DO']
]);

for (const aliases of ALIAS_GROUPS) {
  const code = EXPLICIT_FLAG_CODES.get(normalizeName(aliases[0]));
  if (code) for (const alias of aliases) EXPLICIT_FLAG_CODES.set(normalizeName(alias), code);
}

const REGION_NAME_TO_CODE = new Map();
const REGION_CODES = new Set();
try {
  const displayName = new Intl.DisplayNames(['en'], { type: 'region' });
  for (let first = 65; first <= 90; first += 1) {
    for (let second = 65; second <= 90; second += 1) {
      const code = String.fromCharCode(first, second);
      const label = displayName.of(code);
      if (label && normalizeName(label) !== normalizeName(code) && normalizeName(label) !== 'unknown region') {
        REGION_NAME_TO_CODE.set(normalizeName(label), code);
        REGION_CODES.add(code);
      }
    }
  }
} catch {
  // Browsers without Intl.DisplayNames still get flags from explicit aliases.
}

const WORLD_ATLAS_FLAG_ALIASES = new Map([
  ['dem rep congo', 'CD'], ['democratic republic of the congo', 'CD'],
  ['rep of congo', 'CG'], ['czech republic', 'CZ'], ['bosnia and herz', 'BA'],
  ['central african rep', 'CF'], ['dominican rep', 'DO'], ['eq guinea', 'GQ'],
  ['s sudan', 'SS'], ['w sahara', 'EH'], ['e swatini', 'SZ']
]);

for (const code of EXPLICIT_FLAG_CODES.values()) REGION_CODES.add(code);
for (const code of WORLD_ATLAS_FLAG_ALIASES.values()) REGION_CODES.add(code);

export function countryFlag(name = '') {
  const normalized = normalizeName(name);
  if (!normalized) return '';

  const rawCode = normalized.toUpperCase();
  let code = /^[A-Z]{2}$/.test(rawCode) && REGION_CODES.has(rawCode) ? rawCode : undefined;
  if (!code) code = EXPLICIT_FLAG_CODES.get(normalized) || WORLD_ATLAS_FLAG_ALIASES.get(normalized) || REGION_NAME_TO_CODE.get(normalized);

  if (!code) {
    const canonical = canonicalName(name);
    code = EXPLICIT_FLAG_CODES.get(canonical) || REGION_NAME_TO_CODE.get(canonical);
  }
  if (!code || !/^[A-Z]{2}$/.test(code)) return '';

  return String.fromCodePoint(...[...code].map((letter) => 0x1f1e6 + letter.charCodeAt(0) - 65));
}
